// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
import { paperColors } from './paperColors';
export var Paper = function(mode) {
    var c = paperColors(mode);
    var override = {
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundColor: c.background,
                    // MUI layers a white-alpha gradient over elevated Paper surfaces in dark
                    // mode (brighter at higher elevation) to mimic Material Design's
                    // dark-surface convention. Figma has no such overlay in its Paper spec —
                    // ADS surfaces use a fixed background per elevation instead — so it's
                    // suppressed globally here rather than per-consumer.
                    backgroundImage: 'none'
                }
            }
        }
    };
    return override;
};

//# sourceMappingURL=Paper.js.map